module.exports = __webpack_public_path__ + "static/lesson_5-05189f6201c79319ff0b3329137d5a5a.png";